// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__aeonik_0b46d7', '__aeonik_Fallback_0b46d7'"},"className":"__className_0b46d7","variable":"__variable_0b46d7"};